var _rect, _path, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassicEditor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: -50,
    y: -50,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(50 50)",
    vectorEffect: "non-scaling-stroke"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21759c",
    d: "M83.95 540v499.2h625.3l161.32-170.04 160.58-169.26V40.8H83.95V540zm790.32-306.54l-2.22 29.64h-629l-2.22-29.64-2.22-28.86h637.88l-2.22 28.86zm0 218.4l-2.22 29.64-315.98 2.34-316.72 1.56V423h637.14l-2.22 28.86zM557.55 676.5v27.3h-318.2v-54.6h318.2v27.3zm362.6-21.84c0 7.8-246.42 267.54-253.08 267.54-3.7 0-5.92-61.62-5.92-136.5V649.2h129.5c71.04 0 129.5 2.34 129.5 5.46z",
    vectorEffect: "non-scaling-stroke"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: -50,
    y: -50,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(70.09 81.52)",
    vectorEffect: "non-scaling-stroke"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: -50,
    y: -50,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "matrix(.94 0 0 .94 97.18 42.51)",
    vectorEffect: "non-scaling-stroke"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: -50,
    y: -50,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(70.09 81.52)",
    vectorEffect: "non-scaling-stroke"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZpZXdCb3g9IjAgMCAxMDgwIDEwODAiPgogIDxyZWN0IHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiB4PSItNTAiIHk9Ii01MCIgZmlsbD0ibm9uZSIgcng9IjAiIHJ5PSIwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1MCA1MCkiIHZlY3Rvci1lZmZlY3Q9Im5vbi1zY2FsaW5nLXN0cm9rZSIvPgogIDxwYXRoIGZpbGw9IiMyMTc1OWMiIGQ9Ik04My45NSA1NDB2NDk5LjJoNjI1LjNsMTYxLjMyLTE3MC4wNCAxNjAuNTgtMTY5LjI2VjQwLjhIODMuOTVWNTQwem03OTAuMzItMzA2LjU0LTIuMjIgMjkuNjRoLTYyOWwtMi4yMi0yOS42NC0yLjIyLTI4Ljg2aDYzNy44OGwtMi4yMiAyOC44NnptMCAyMTguNC0yLjIyIDI5LjY0LTMxNS45OCAyLjM0LTMxNi43MiAxLjU2VjQyM2g2MzcuMTRsLTIuMjIgMjguODZ6TTU1Ny41NSA2NzYuNXYyNy4zaC0zMTguMnYtNTQuNmgzMTguMnYyNy4zem0zNjIuNi0yMS44NGMwIDcuOC0yNDYuNDIgMjY3LjU0LTI1My4wOCAyNjcuNTQtMy43IDAtNS45Mi02MS42Mi01LjkyLTEzNi41VjY0OS4yaDEyOS41YzcxLjA0IDAgMTI5LjUgMi4zNCAxMjkuNSA1LjQ2eiIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIi8+CiAgPHJlY3Qgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHg9Ii01MCIgeT0iLTUwIiBmaWxsPSJub25lIiByeD0iMCIgcnk9IjAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcwLjA5IDgxLjUyKSIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIi8+CiAgPHJlY3Qgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHg9Ii01MCIgeT0iLTUwIiBmaWxsPSJub25lIiByeD0iMCIgcnk9IjAiIHRyYW5zZm9ybT0ibWF0cml4KC45NCAwIDAgLjk0IDk3LjE4IDQyLjUxKSIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIi8+CiAgPHJlY3Qgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHg9Ii01MCIgeT0iLTUwIiBmaWxsPSJub25lIiByeD0iMCIgcnk9IjAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcwLjA5IDgxLjUyKSIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIi8+Cjwvc3ZnPgo=";
export { SvgClassicEditor as ReactComponent };